import { baseProjection } from "./base.projection";

export class subscriptionUsageForTopNav extends baseProjection {

    orders: string = "";
    expiryDate: string = "";
    allocatedOrders: string = "";
};

export class subscriptionList extends baseProjection {

    users: string = "";
    orders: string = "";
    warehouses: string = "";
};

export class subscriptionDetailForTopNav extends baseProjection {

    status: string = "";
    "plan.planType": string = "";
    "plan.planName": string = "";

    constructor() {
        super('');
    }
};

export class subscriptionDetail extends baseProjection {

    plan: string = "";
    status: string = "";
    endDate: string = "";
    quantity: number = 0;
    startDate: string = "";
    subscriptionId: number = 0;

    constructor() {
        super('');
    }
};

export class subscriptionPlanItem extends baseProjection {

    planName: string = "";
    sequenceId: number = 0;

    constructor() {
        super('');
    }
};

export class subscriptionDetailForAdminOverview extends baseProjection {

    
    status: string = "";
    endDate: string = "";
    startDate: string = "";
    companyId: string = "";
    consumedOrders: string = "";
    "plan.options": string = "";
    "plan.planType": string = "";
    "plan.planName": string = "";

    constructor() {
        super('');
    }
};